import styled from "@emotion/styled";

const ArticleAsideBannerContent = styled.div`
position: relative;
z-index: 2;
`

export default ArticleAsideBannerContent